<template>
  <v-btn text block @click="clickBtn" class="theme-btn" :class=" `btn-${btnTheme}`">
    <span v-if="btnIcon">
      <img :src="btnIcon" />
    </span>
    <span>{{btnText}}</span>
  </v-btn>
</template>
<script>
export default {
  methods: {
    clickBtn() {
      this.$emit('click')
    }
  },
  props: {
    btnText: {
      type: String
    },
    btnTheme: {
      type: String,
      validator: value => {
        return ['funda-blue', 'kakao', 'apple'].indexOf(value) !== -1
      }
    },
    btnIcon: {
      type: String
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/design/_colors.scss';

.theme-btn {
  text-transform: none;
  letter-spacing: normal;
  font-size: 18px;
  font-weight: 700;
  line-height: 56px;
  height: 56px !important;

  span img {
    margin-right: 6px;
    height: 23px;
  }
}
.btn {
  &-funda-blue {
    color: $white;
    background-color: $blue;
  }
  &-kakao {
    color: #252525;
    background-color: $yellow;
  }
  &-apple {
    color: $white;
    background-color: #000000;
  }
}
</style>
